module.exports = __webpack_public_path__ + "static/img/mini-bus-blue.b5429a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/mini-bus-blue.svg
// module id = /cI4
// module chunks = 74